var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',_vm._b({directives:[{name:"inputPhoneMask",rawName:"v-inputPhoneMask"}],attrs:{"value":_vm.value,"placeholder":"7 (xxx) xxx - xx - xx"},on:{"input":_vm.updateNumber}},'b-form-input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }